import React from 'react' // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types'
import 'balloon-css/balloon.min.css'

const Tooltip = ({ title, position, children }) => (
    <span data-balloon={ title } data-balloon-pos={ position } id="show-tip">{ children }</span>
)

Tooltip.propTypes = {
    title    : PropTypes.string,
    position : PropTypes.oneOf(['up', 'down', 'left', 'right'])
}

Tooltip.defaultProps = {
    position: 'up'
}

export default Tooltip
